{
  "version": 1,
  "asset_id": "8272a3fc-057d-4aa2-a53b-833d7924d69d",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/8272a3fc-057d-4aa2-a53b-833d7924d69d/bypass-normal-boxed-en-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/8272a3fc-057d-4aa2-a53b-833d7924d69d/bypass-normal-boxed-en-480.webp",
  "original_filename": "bypass-normal-boxed-en-480.webp",
  "size": 13900,
  "content_type": "image/webp",
  "created_at": "2026-10-06T14:08:54Z"
}
